import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import saveOcsTranslationSettings from '../services/saveOcsTranslationSettings';
import store from '../store/store';
import storeOutlookOptions from './storeOutlookOptions';
import TranslationSettings from '../store/schema/TranslationSettings';
import {
    createTranslationModeUpdate,
    createTargetLanguageUpdate,
    createExcludedLanguagesUpdate,
} from './updateTranslationSettings';

export default function mergeSettings(
    ooSettings: TranslationSettings,
    ocsSettings: TranslationSettings,
    firstRun: boolean
) {
    let updateOo = false;
    let updateOcsLanguages = false;
    const ocsUpdates = [];
    const scope = getUserConfiguration().SessionSettings.UserEmailAddress;

    // Remove invalid entries from excluded languages list from both storages.
    if (removeInvalidLanguages(ooSettings)) {
        updateOo = true;
    }
    if (removeInvalidLanguages(ocsSettings)) {
        updateOcsLanguages = true;
    }

    if (
        ocsSettings.translationMode == null ||
        (firstRun && ocsSettings.translationMode !== ooSettings.translationMode)
    ) {
        createTranslationModeUpdate(ocsUpdates, ooSettings.translationMode, scope);
    } else if (ocsSettings.translationMode !== ooSettings.translationMode) {
        ooSettings.translationMode = ocsSettings.translationMode;
        updateOo = true;
    }

    if (!ooSettings.targetLanguage) {
        ooSettings.targetLanguage = store.userLanguageTag;
        updateOo = true;
    }
    if (
        !ocsSettings.targetLanguage ||
        (firstRun && ocsSettings.targetLanguage !== ooSettings.targetLanguage)
    ) {
        createTargetLanguageUpdate(ocsUpdates, ooSettings.targetLanguage, scope);
    } else if (ocsSettings.targetLanguage !== ooSettings.targetLanguage) {
        ooSettings.targetLanguage = ocsSettings.targetLanguage;
        updateOo = true;
    }

    if (
        ocsSettings.excludedLanguages == null ||
        (firstRun &&
            arrayContentsDiffer(ooSettings.excludedLanguages, ocsSettings.excludedLanguages))
    ) {
        if (
            !!ooSettings.targetLanguage &&
            ooSettings.excludedLanguages.indexOf(ooSettings.targetLanguage) < 0
        ) {
            ooSettings.excludedLanguages.push(ooSettings.targetLanguage);
            updateOo = true;
        }
        createExcludedLanguagesUpdate(ocsUpdates, ooSettings.excludedLanguages, scope);
    } else {
        if (updateOcsLanguages) {
            createExcludedLanguagesUpdate(ocsUpdates, ooSettings.excludedLanguages, scope);
        }
        if (arrayContentsDiffer(ooSettings.excludedLanguages, ocsSettings.excludedLanguages)) {
            ooSettings.excludedLanguages = ocsSettings.excludedLanguages;
            updateOo = true;
        }
    }

    if (ocsUpdates.length > 0) {
        saveOcsTranslationSettings(ocsUpdates);
    }
    if (updateOo || firstRun) {
        storeOutlookOptions(ooSettings);
    }
}

function arrayContentsDiffer(ooLanguages: string[], ocsLanguages: string[]) {
    if (ooLanguages.length != ocsLanguages.length) {
        return true;
    }
    for (let i = 0; i < ooLanguages.length; i++) {
        if (!ocsLanguages.includes(ooLanguages[i])) {
            return true;
        }
    }
    return false;
}

function removeInvalidLanguages(settings: TranslationSettings) {
    if (!settings || !settings.excludedLanguages || settings.excludedLanguages.length <= 0) {
        return false;
    }
    let removed = false;
    const validLanguages = [];
    for (let i = 0; i < settings.excludedLanguages.length; i++) {
        const lang = settings.excludedLanguages[i];
        if (lang && store.supportedLanguageMap.has(lang)) {
            validLanguages.push(lang);
        } else {
            removed = true;
        }
    }

    if (removed) {
        settings.excludedLanguages = validLanguages;
        return true;
    }
    return false;
}
